import track, { errorTypes } from 'c9-tracking';
import { SectionHeader, formatPhone } from '@flos/react-ui';
import React, { useEffect, useState } from 'react';

import { FALLBACK_URL } from '../constants';
import useResource from '../hooks/resource';
import { Submission } from '../types';
import log from '../utils/logger';

const usePayload = () => {
  const [submission, setSubmission] = useState<Submission | null>(null);

  useEffect(() => {
    try {
      const payload = window.sessionStorage.getItem('write-to-us-submission');

      if (!payload) {
        throw new Error('No submission found');
      }

      setSubmission(JSON.parse(payload));
    } catch (e) {
      // falling back to read from query string
      log.warn('Unable to read payload from session storage.', e, 'Attempting to read from query string');

      const payload = getPayloadFromQuery();
      if (payload) {
        setSubmission(payload);
      } else {
        track.fault('Invalid access to Receipt page', errorTypes.user);
        window.location.replace(FALLBACK_URL);
      }
    }

    track.ready(true, 'writeToUsReceiptPageReady');
  }, []);

  return submission;
};

export const getPayloadFromQuery = () => {
  const payload = window.location.search
    .split(/[?&]/)
    .filter(Boolean)
    .reduce((val, curr) => {
      const [key, value] = curr.split(/=/);
      return {
        ...val,
        [key]: decodeURIComponent(value),
      };
    }, {});
  if (
    payload.hasOwnProperty('topic') &&
    payload.hasOwnProperty('name') &&
    payload.hasOwnProperty('mobile') &&
    payload.hasOwnProperty('email')
  ) {
    return payload as Submission; // duck-typed to Submission
  } else {
    return undefined;
  }
};

const Reciept = () => {
  const resource = useResource();
  const submission = usePayload();

  if (!submission) {
    return null;
  }

  return (
    <>
      <SectionHeader>{resource('label.receipt.header')}</SectionHeader>
      <div
        dangerouslySetInnerHTML={{
          __html: resource('label.receipt.message')
            .replace(/\{0\}/g, submission.name)
            .replace(/\{1\}/g, submission.email)
            .replace(/\{2\}/g, String(formatPhone(submission.mobile) ?? ''))
            .replace(/\\n/g, '<br/>'),
        }}
      ></div>
    </>
  );
};

export default Reciept;
